import axiosInstance from './axiosInstance';
const apiClient = {
  get: async (url, config = {}) => {
    const response = await axiosInstance.get(url, config);
    return response;
  },

  post: async (url, data, config = {}) => {
    const response = await axiosInstance.post(url, data, config);
    return response;
  },

  put: async (url, data, config = {}) => {
    const response = await axiosInstance.put(url, data, config);
    return response;
  },

  delete: async (url, config = {}) => {
    const response = await axiosInstance.delete(url, config);
    return response;
  },

  patch:async (url, data, config = {}) => {
    const response = await axiosInstance.patch(url, data, config);
    return response;
  },
};

export default apiClient;